<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <div class="vendor-form-wrapper">
      <input-text
        :label="'Nama Perusahaan'"
        :modelName="'vendor_name'"
        :isRequired="false"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="true"
      />
      <input-text
        :label="'Alamat Perusahaan'"
        :modelName="'vendor_address'"
        :isRequired="false"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="true"
      />
      <input-text
        :label="'Jenis Badan Usaha'"
        :modelName="'kplh_choosed_bu'"
        :isRequired="false"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="true"
      />
      <input-bidang
        :storeName="'kplhStore'"
        :modelName="'addedKbli'"
        :label="'Bidang Usaha / Jenis Pekerjaan'"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :modalName="'modal_add_kbli'"
        :isRequired="false"
        :disabled="true"
      />
      <input-text
        :label="'Nama PIC/PJO'"
        :modelName="'pic_name'"
        :isRequired="true"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="$store.state.kplhStore.is_sipm_approved"
      />
      <input-text
        :label="'Posisi PIC/PJO'"
        :modelName="'pic_position'"
        :isRequired="true"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="$store.state.kplhStore.is_sipm_approved"
      />
      <input-text
        :label="'Email PIC/PJO'"
        :modelName="'pic_email'"
        :isRequired="true"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="$store.state.kplhStore.is_sipm_approved"
      />
      <input-phone
        :label="'No. Kontak PIC/PJO'"
        :modelName="'pic_phone'"
        :subModelName="'pic_phone_code'"
        :isRequired="true"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="$store.state.kplhStore.is_sipm_approved"
      />
      <!-- <div class="vendor-form-wrapper">
        <checkbox-form
          :label="'Kode Bidang Usaha GEMS'"
          :tables="[
            {
              name: 'Jenis Pekerjaan',
              obj_name: 'JENPEK',
              css: 'column55 mr10 all-column',
              input: false,
              type: '',
            },
            {
              name: 'Kode KBLI',
              obj_name: 'KBUG',
              css: 'column15 mr10 all-column',
              input: false,
              type: '',
            },
            {
              name: 'Nilai Risiko',
              obj_name: 'NRESIKO',
              css: 'column15 mr10',
              input: false,
              type: '',
            },
            {
              name: 'Tingkat Risiko',
              obj_name: 'TRESIKO',
              css: 'column15 mr10',
              input: false,
              type: '',
            },
          ]"
          :isRequired="true"
          :modalName="'modal_add_bidang_usaha_gems'"
          :modelName="'addedBidangUsahaGems'"
          :mutationName="'kplhStore/SET_KPLH_FORM'"
          :storeName="'kplhStore'"
          :operationAdd="'bidang_usaha_add'"
          :editMutation="'kplhStore/SET_SISTEM_MANAJEMEN'"
          :disabled="$store.state.kplhStore.is_sipm_approved"
        />
      </div> -->

      <input-tingkat-resiko
        :storeName="'kplhStore'"
        :label="'Hasil penilaian Tingkat Risiko'"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :isRequired="false"
        :disabled="$store.state.kplhStore.is_sipm_approved"
      />
      <input-select
        :options="company"
        :label="'Pendaftaran Company GEMS'"
        :modelName="'choosed_company'"
        :isRequired="true"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="false"
      />
    </div>
    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan dan Lanjutkan
      </div>
    </div>

    <Kbli
      :storeName="'kplhStore'"
      :modelName="'addedKbli'"
      :label="'Bidang Usaha / Jenis Pekerjaan'"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :modalName="'modal_add_kbli'"
      :isRequired="true"
      v-if="$store.state.kplhStore.modal_add_kbli"
    />
  </div>
</template>

<script>
import InputAddress from '../../components/forms/input-address.vue'
import InputBu from '../../components/forms/input-bu.vue'
import InputDate from '../../components/forms/input-date.vue'
import InputPhone from '../../components/forms/input-phone.vue'
import InputText from '../../components/forms/input-text.vue'
import InputPerusahaan from '../../components/forms/input-perusahaan.vue'
import InputBidang from '../../components/forms/input-bidang.vue'
import Kbli from '@/components/customModal/addBidangUsaha.vue'
import InputCheckbox from '../../components/forms/input-checkbox.vue'
import AddPerusahaan from '@/components/customModal/addPerusahaan.vue'
import InputTingkatResiko from '@/components/forms/input-tingkat-resiko.vue'
import CheckboxForm from '../../components/forms/checkbox-form.vue'
import InputSelect from '../../components/forms/input-select.vue'

export default {
  components: {
    InputText,
    InputDate,
    InputAddress,
    InputBu,
    InputPhone,
    InputPerusahaan,
    InputBidang,
    Kbli,
    InputCheckbox,
    AddPerusahaan,
    InputTingkatResiko,
    CheckboxForm,
    InputSelect,
  },
  data() {
    return {
      customCode: '',
      company: [],
    }
  },
  async created() {
    const gems = await this.$gemsCompanies()

    this.company = gems
  },
  methods: {
    checkForm() {
      const {
        pic_name,
        pic_position,
        pic_email,
        pic_phone,
        choosed_company,
        addedBidangUsahaGems,
      } = this.$store.state.kplhStore

      let arr = [
        [pic_name, `Nama PIC`],
        [pic_position, 'Posisi PIC'],
        [pic_phone, 'No. Telpon PIC'],
        [this.isEmailValid(pic_email), 'Email PIC'],
        [choosed_company, 'Pendaftaran Company GEMS'],
      ]

      return this.multiConditions(arr)
    },
    goBack() {
      this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'register' })
    },
    goNext() {
      if (this.checkForm()) {
        this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupah' })
        this.$store.commit('kplhStore/PROCESSING_KPLH_FOR_DRAFT', {
          onSuccess: () => {
            this.$store.commit('kplhStore/SET_KPLH_FORM', {
              name: 'grupah_step',
              value: true,
            })
          },
        })
      }
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
